import "./user.css"
function User(){
    return(
        <>
        <div className="user">
           <div className="continer">
    <h4>From the heart of the experience</h4>
    <h5>Listen to what those who journeyed with us have to say</h5>
</div>
<div className="content">
    <div className="row g-2">
        <div className="col-md-12">
            <div className="box">
                <div className="info">
                    <div className="letters">
                        <div className="letter">
M
                        </div>

                    </div>
                    <div className="user">
                        <h5>User One</h5>
                        <div className="icon">
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>

                        </div>
                    </div>
                </div>
                <div className="text">
    <p>
        "A truly wonderful center in every sense of the word! The ease of booking and the quick response to inquiries amazed me. The doctors are professional and explain the condition in detail while providing clear treatment plans. I feel great confidence when dealing with this center."
    </p>
</div>
            </div>
        </div>
         <div className="col-md-12">
            <div className="box">
                <div className="info">
                    <div className="letters">
                        <div className="letter">
O
                        </div>

                    </div>
                    <div className="user">
                        <h5>User Two</h5>
                        <div className="icon">
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>

                        </div>
                    </div>
                </div>
  <div className="text">
    <p>
        "Outstanding service and refined treatment from all the medical staff. The place is very clean and equipped with modern devices. I appreciated their attention to patient comfort and the valuable medical advice provided after the examination. I highly recommend it to anyone seeking exceptional medical care."
    </p>
</div>
            </div>
        </div>
         <div className="col-md-12">
            <div className="box">
                <div className="info">
                    <div className="letters">
                        <div className="letter">
A
                        </div>

                    </div>
                    <div className="user">
                        <h5>User Three</h5>
                        <div className="icon">
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>

                        </div>
                    </div>
                </div>
<div className="text">
    <p>
        "My experience with this medical center was more than wonderful! From the moment of reception until the end of the consultation, I felt complete care and high professionalism from all the staff. The doctors are distinguished and experts in their specialties. I recommend everyone to visit this exceptional place."
    </p>
</div>
            </div>
        </div>
         <div className="col-md-12">
            <div className="box">
                <div className="info">
                    <div className="letters">
                        <div className="letter">
R
                        </div>

                    </div>
                    <div className="user">
                        <h5>User Four</h5>
                        <div className="icon">
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>

                        </div>
                    </div>
                </div>
<div className="text">
    <p>"Excellence in medical care"</p>
</div>

            </div>
        </div>
         <div className="col-md-12">
            <div className="box">
                <div className="info">
                    <div className="letters">
                        <div className="letter">
N
                        </div>

                    </div>
                    <div className="user">
                        <h5>User Five</h5>
                        <div className="icon">
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>

                        </div>
                    </div>
                </div>
<div className="text">
    <p>"Where patients feel valued"</p>
</div>


            </div>
        </div>
           <div className="col-md-12">
            <div className="box">
                <div className="info">
                    <div className="letters">
                        <div className="letter">
S
                        </div>

                    </div>
                    <div className="user">
                        <h5>User Six</h5>
                        <div className="icon">
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>
                            <i class="fa-solid fa-star" style={{"color":"rgb(255, 212, 59)"}}></i>

                        </div>
                    </div>
                </div>
<div className="text">
    <p>"Professional doctors, trusted service"</p>
</div>



            </div>
        </div>
    </div>
</div>
        </div>
        </>
    )
}
export default User